import { type FlowEvaluationBlockConfig, FlowEvaluationBlockConfigSchema } from 'flow-schema';

import { EvaluationFormFields } from './FormFields';
import { evaluationDocumentationMarkdown } from './documentation';
import { getDefaultEvaluationConfig } from './utils';
import { type BlockConfigProps } from '../../types';

export const evaluationNodeConfig: BlockConfigProps<FlowEvaluationBlockConfig> = {
  defaultLabelPrefix: 'evaluation',
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultConfig: getDefaultEvaluationConfig(),
  configFields: {
    schema: FlowEvaluationBlockConfigSchema,
    FormFields: EvaluationFormFields,
  },
  documentationMarkdown: evaluationDocumentationMarkdown,
};
